import { render } from "./WebFooter.vue?vue&type=template&id=7c856b84&scoped=true"
import script from "./WebFooter.vue?vue&type=script&lang=js"
export * from "./WebFooter.vue?vue&type=script&lang=js"

import "./WebFooter.vue?vue&type=style&index=0&id=7c856b84&scoped=true&lang=css"

import exportComponent from "C:\\Work\\house_keeping\\website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c856b84"]])

export default __exports__